export default {"src":"/_next/static/media/notifications.f7cfdac9.svg","height":44,"width":50};